import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBettingMarketMapping } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";

export const useDeleteBettingMarketMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ marketId, id }: { marketId: number; id: number }) =>
      deleteBettingMarketMapping(marketId, id),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingMarketsQueryKeys.BettingMarketMappings, variables.marketId],
      });
    },
  });
};
